import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * NOT-339 §3.3 — the standalone Contract aggregate is retired. Recurring
 * agreements are Jobs (`bookingType=RECURRING`); this route and any child
 * `/dashboard/contracts/*` path redirect to the Jobs list. The parent
 * `beforeLoad` fires before any child, so it covers `/dashboard/contracts/:id`
 * (external links) too.
 */
export const Route = createFileRoute('/_dashboard/dashboard/contracts')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/jobs' });
  },
  component: () => null,
});
